import { Box, Stack, styled, Typography, TypographyProps } from '@mui/material';

export const GuideContainer = styled(Box)(({ theme }) => ({
  maxWidth: 600,
  margin: '0 auto',
  textAlign: 'center',
  padding: '48px 24px',
  backgroundColor: theme.palette.neutral[1000],
  color: theme.palette.common.white,
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
}));

export const GuideTitle = styled((props: TypographyProps) => (
  <Typography variant="h3" {...props} />
))(({ theme }) => ({
  color: theme.palette.neutral.min,
}));

export const GuideContent = styled(Stack)(({ theme }) => ({
  width: '432px',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4),
  margin: 'auto 0',
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
}));

export const GuideStepsContainer = styled(Stack)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  marginBottom: 'auto',
}));

export const GuideStep = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(2),
  textAlign: 'left',
  width: '100%',
}));

export const TextNormal = styled((props: TypographyProps) => (
  <Typography variant="body2" component="span" {...props} />
))(({ theme }) => ({
  color: theme.palette.neutral[300],
}));

export const TextHighlight = styled((props: TypographyProps) => (
  <Typography variant="body2Bold" component="span" {...props} />
))(({ theme }) => ({
  color: theme.palette.common.white,
}));

export const IconWrapper = styled(Box)(({ theme }) => ({
  width: 48,
  height: 48,
  borderRadius: '50%',
  backgroundColor: theme.palette.neutral[800],
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
}));
